import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { CheckCircle } from "@phosphor-icons/react";

export default function RecentPurchaseToast() {
  const [items, setItems] = useState([]);
  const [idx, setIdx] = useState(0);
  const [show, setShow] = useState(false);

  useEffect(() => {
    api.get("/recent-purchases").then(r => setItems(r.data || [])).catch(()=>{});
  }, []);

  useEffect(() => {
    if (!items.length) return;
    const cycle = () => {
      setShow(true);
      setTimeout(()=>setShow(false), 4500);
      setTimeout(()=>setIdx(p => (p + 1) % items.length), 5000);
    };
    const initial = setTimeout(cycle, 5000);
    const t = setInterval(cycle, 12000);
    return () => { clearTimeout(initial); clearInterval(t); };
  }, [items]);

  if (!items.length) return null;
  const item = items[idx];
  const minutesAgo = Math.max(1, Math.floor((Date.now() - new Date(item.created_at).getTime())/60000));
  const productName = item.items?.[0]?.name || "an item";

  return (
    <div className={`fixed bottom-5 left-5 z-40 transition-all duration-500 ${show?"opacity-100 translate-y-0":"opacity-0 translate-y-3 pointer-events-none"}`} data-testid="recent-purchase-toast">
      <div className="bg-white border border-[var(--bm-border)] rounded-2xl shadow-lg p-3 pr-5 flex items-center gap-3 max-w-xs">
        <div className="bg-[#f4f4f4] rounded-xl w-10 h-10 flex items-center justify-center"><CheckCircle size={20} weight="thin" className="text-[var(--bm-gold)]"/></div>
        <div className="text-xs">
          <div className="font-medium">{item.customer_name} from {item.shipping_country}</div>
          <div className="text-[var(--bm-muted)] line-clamp-2">just purchased {productName} · {minutesAgo}m ago</div>
        </div>
      </div>
    </div>
  );
}
